export const dailyQuestions = {
  conversation1: {
    id: 1,
    title: "Moving Plans",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/daily/daily1.mp3",
        script: `<mark>M</mark>: Hey, Sarah. I heard you're <mark>moving</mark> to a new apartment next month. Have you started packing yet?
<span class="translation">(안녕하세요, Sarah. 다음 달에 새 아파트로 이사한다고 들었어요. 짐 싸기를 시작하셨나요?)</span>

<mark>W</mark>: Not really. I've been so busy with work that I haven't had time to pack. But I did <mark>schedule a moving company</mark> for next Saturday.
<span class="translation">(아니요. 일이 너무 바빠서 짐 쌀 시간이 없었어요. 하지만 다음 주 토요일에 이삿짐 센터는 예약했어요.)</span>

<mark>M</mark>: That's good. Have you set up the <mark>utilities</mark> for the new place? Things like electricity and internet can take a few days to get activated.
<span class="translation">(잘됐네요. 새집 공과금은 신청하셨나요? 전기나 인터넷 같은 것들은 개통하는 데 며칠 걸릴 수 있거든요.)</span>

<mark>W</mark>: Oh, I hadn't thought about that. I'll <mark>call the service providers</mark> today to arrange everything before the move.
<span class="translation">(아, 그건 생각 못 했네요. 이사 전에 모든 것을 준비하기 위해 오늘 서비스 업체에 연락해볼게요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the woman</mark> planning to do?",
        options: {
          A: "<mark>Sell</mark> her house",
          B: "<mark>Move</mark> to a <mark>new</mark> <mark>apartment</mark>",
          C: "Buy <mark>new</mark> <mark>furniture</mark>",
          D: "<mark>Rent</mark> out her current home",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Move to a new apartment

대본 키워드: "I heard you're moving to a new apartment next month"
보기 키워드: "Move to a new apartment"

❌ 오답 트랩:
(A) Sell her house 
→ 집을 판매하는 것이 아닌 이사

(C) Buy new furniture 
→ 가구 구입이 아닌 이사

(D) Rent out her current home 
→ 현재 집 임대가 아닌 이사`,
      },
      {
        id: 2,
        question: "What has <mark>the woman</mark> already arranged?",
        options: {
          A: "Packing all her <mark>belongings</mark>",
          B: "Setting up <mark>electricity</mark> and <mark>internet</mark>",
          C: "Hiring a <mark>moving</mark> <mark>company</mark>",
          D: "Notifying her <mark>landlord</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Hiring a moving company

대본 키워드: "I did schedule a moving company for next Saturday"
보기 키워드: "Hiring a moving company"

❌ 오답 트랩:
(A) Packing all her belongings 
→ 아직 짐을 싸지 않음

(B) Setting up electricity and internet 
→ 아직 공과금 신청을 하지 않음

(D) Notifying her landlord 
→ 집주인 통보에 대한 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "Start packing her <mark>belongings</mark>",
          B: "Look for a new <mark>apartment</mark>",
          C: "Call the <mark>service</mark> <mark>providers</mark>",
          D: "<mark>Cancel</mark> her moving plans",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Call the service providers

대본 키워드: "I'll call the service providers today to arrange everything"
보기 키워드: "Call the service providers"

❌ 오답 트랩:
(A) Start packing her belongings 
→ 짐 싸기가 아닌 서비스 업체 연락

(B) Look for a new apartment 
→ 새 아파트 찾기가 아닌 서비스 업체 연락

(D) Cancel her moving plans 
→ 이사 취소가 아닌 서비스 업체 연락`,
      },
    ],
  },

  // ... existing code ...

  conversation2: {
    id: 2,
    title: "Morning Workout Plans",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/daily/daily2.mp3",
        script: `<mark>M</mark>: Hey, Lisa. I was thinking about starting a <mark>morning workout routine</mark>. Would you be interested in joining me?
<span class="translation">(안녕하세요, Lisa. 아침 운동 루틴을 시작하려고 하는데요. 저와 함께 하시겠어요?)</span>

<mark>W</mark>: That sounds great! I've been meaning to exercise more, but I find it hard to <mark>stay motivated alone</mark>. What time are you planning to work out?
<span class="translation">(좋네요! 운동을 더 하고 싶었는데, 혼자서는 동기부여가 잘 안돼요. 몇 시에 운동하실 계획이세요?)</span>

<mark>M</mark>: I was thinking around <mark>6:30 AM</mark> before work. That way, we can finish early and still have time to get ready for the day.
<span class="translation">(출근 전 오전 6시 30분 정도로 생각하고 있어요. 그러면 일찍 끝내고 하루를 준비할 시간도 있을 거예요.)</span>

<mark>W</mark>: Hmm, 6:30 is a bit early for me, but I can try. Let's <mark>meet at the gym tomorrow morning</mark> and see how it goes.
<span class="translation">(음, 6시 30분은 좀 이른데, 한번 해볼게요. 내일 아침에 헬스장에서 만나서 어떤지 봐요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are the speakers mainly discussing?",
        options: {
          A: "Buying a gym <mark>membership</mark>",
          B: "Taking a <mark>yoga</mark> class together",
          C: "Exercising together in the <mark>morning</mark>",
          D: "Participating in a <mark>marathon</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Exercising together in the morning

대본 키워드: "starting a morning workout routine. Would you be interested in joining me?"
보기 키워드: "Exercising together in the morning"

❌ 오답 트랩:
(A) Buying a gym membership 
→ 헬스장 회원권 구매가 아닌 아침 운동 계획

(B) Taking a yoga class together 
→ 요가 수업이 아닌 아침 운동 계획

(D) Participating in a marathon 
→ 마라톤 참가가 아닌 아침 운동 계획`,
      },
      {
        id: 2,
        question:
          "Why does <mark>the woman</mark> say she has trouble exercising?",
        options: {
          A: "She has an <mark>injury</mark>",
          B: "She doesn't have enough <mark>time</mark>",
          C: "She finds it hard to stay <mark>motivated</mark> alone",
          D: "She prefers to work out in the <mark>evening</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) She finds it hard to stay motivated alone

대본 키워드: "I find it hard to stay motivated alone"
보기 키워드: "She finds it hard to stay motivated alone"

❌ 오답 트랩:
(A) She has an injury 
→ 부상에 대한 언급 없음

(B) She doesn't have enough time 
→ 시간 부족에 대한 언급 없음

(D) She prefers to work out in the evening 
→ 저녁 운동 선호에 대한 언급 없음`,
      },
      {
        id: 3,
        question: "What arrangement did the speakers make?",
        options: {
          A: "Buy <mark>new</mark> workout <mark>clothes</mark>",
          B: "Look for a <mark>personal</mark> <mark>trainer</mark>",
          C: "Meet at the gym the <mark>next morning</mark>",
          D: "Join a <mark>local</mark> <mark>running</mark> <mark>club</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Meet at the gym the next morning

대본 키워드: "Let's meet at the gym tomorrow morning and see how it goes"
보기 키워드: "Meet at the gym the next morning"

❌ 오답 트랩:
(A) Buy new workout clothes 
→ 운동복 구매에 대한 언급 없음

(B) Look for a personal trainer 
→ 개인 트레이너 관련 언급 없음

(D) Join a local running club 
→ 달리기 클럽 가입 관련 언급 없음`,
      },
    ],
  },

  // ... existing code ...

  conversation3: {
    id: 3,
    title: "Running Late",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/daily/daily3.mp3",
        script: `<mark>W</mark>: Hi, Jake. I was supposed to meet you at 9, but I'm running late.
<span class="translation">(안녕하세요, Jake. 9시에 만나기로 했는데, 늦어지고 있어요.)</span>

<mark>M</mark>: Oh, what happened?
<span class="translation">(아, 무슨 일이에요?)</span>

<mark>W</mark>: There was an <mark>accident on the highway</mark>, and the <mark>traffic</mark> is really bad.
<span class="translation">(고속도로에서 사고가 났고, 교통이 정말 안 좋아요.)</span>

<mark>M</mark>: I see. How long do you think it'll take?
<span class="translation">(그렇군요. 얼마나 걸릴 것 같아요?)</span>

<mark>W</mark>: Maybe 20 more minutes. I'm really sorry for the <mark>delay</mark>.
<span class="translation">(아마 20분 정도 더 걸릴 것 같아요. 지연되어서 정말 죄송해요.)</span>

<mark>M</mark>: No worries. I'll <mark>wait here</mark>. Drive safely!
<span class="translation">(걱정 마세요. 여기서 기다릴게요. 안전운전하세요!)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What problem does <mark>the woman</mark> have?",
        options: {
          A: "She missed an important <mark>meeting</mark>",
          B: "She cannot find her car <mark>keys</mark>",
          C: "She went to the <mark>wrong</mark> <mark>location</mark>",
          D: "She is stuck in <mark>traffic</mark>",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) She is stuck in traffic

대본 키워드: "There was an accident on the highway, and the traffic is really bad"
보기 키워드: "She is stuck in traffic"

❌ 오답 트랩:
(A) She missed an important meeting 
→ 미팅을 놓친 것이 아닌 교통 체증으로 인한 지연

(B) She cannot find her car keys 
→ 차 키를 찾지 못한 것이 아닌 교통 체증

(C) She went to the wrong location 
→ 잘못된 장소가 아닌 교통 체증`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> apologize for?",
        options: {
          A: "<mark>Forgetting</mark> about the <mark>meeting</mark>",
          B: "<mark>Rescheduling</mark> the <mark>appointment</mark>",
          C: "Making a <mark>wrong</mark> <mark>turn</mark>",
          D: "<mark>Being late</mark> for the meeting",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) Being late for the meeting

대본 키워드: "I'm really sorry for the delay"
보기 키워드: "Being late for the meeting"

❌ 오답 트랩:
(A) Forgetting about the meeting 
→ 약속을 잊은 것이 아닌 지연에 대한 사과

(B) Rescheduling the appointment 
→ 일정 변경이 아닌 지연에 대한 사과

(C) Making a wrong turn 
→ 길을 잘못 든 것이 아닌 지연에 대한 사과`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "<mark>Wait</mark> for the woman at the meeting place",
          B: "Ask the woman to take a <mark>different</mark> <mark>route</mark>",
          C: "Postpone the meeting to <mark>another</mark> <mark>day</mark>",
          D: "<mark>Leave</mark> the location without meeting her",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Wait for the woman at the meeting place

대본 키워드: "No worries. I'll wait here"
보기 키워드: "Wait for the woman at the meeting place"

❌ 오답 트랩:
(B) Ask the woman to take a different route 
→ 다른 경로를 제안하지 않고 기다리기로 함

(C) Postpone the meeting to another day 
→ 일정을 연기하지 않고 기다리기로 함

(D) Leave the location without meeting her 
→ 떠나지 않고 기다리기로 함`,
      },
    ],
  },
  conversation4: {
    id: 4,
    title: "Meeting Rescheduling",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/daily/daily4.mp3",
        script: `<mark>M</mark>: Hi, Rachel. I wanted to check if we're still on for our meeting tomorrow.
<span class="translation">(안녕하세요, Rachel. 내일 미팅이 여전히 유효한지 확인하고 싶어서요.)</span>

<mark>W</mark>: Actually, I was about to call you. Something <mark>urgent</mark> came up at work, and I need to <mark>reschedule</mark>.
<span class="translation">(사실 전화드리려던 참이었어요. 직장에서 급한 일이 생겨서 일정을 변경해야 할 것 같아요.)</span>

<mark>M</mark>: Oh, I see. When would be a good time for you?
<span class="translation">(아, 그렇군요. 언제가 괜찮으신가요?)</span>

<mark>W</mark>: How about Friday afternoon instead?
<span class="translation">(대신 금요일 오후는 어떠신가요?)</span>

<mark>M</mark>: That should work. Let me <mark>confirm and get back to you</mark>.
<span class="translation">(괜찮을 것 같아요. 확인하고 다시 연락드리겠습니다.)</span>

<mark>W</mark>: Sounds good. Thanks for understanding!
<span class="translation">(좋아요. 이해해주셔서 감사합니다!)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the conversation mainly about?",
        options: {
          A: "Preparing for a <mark>presentation</mark>",
          B: "Booking a <mark>conference</mark> <mark>room</mark>",
          C: "Rescheduling a <mark>meeting</mark>",
          D: "Organizing a team <mark>event</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Rescheduling a meeting

대본 키워드: "Something urgent came up at work, and I need to reschedule"
보기 키워드: "Rescheduling a meeting"

❌ 오답 트랩:
(A) Preparing for a presentation 
→ 프레젠테이션이 아닌 미팅 일정 변경

(B) Booking a conference room 
→ 회의실 예약이 아닌 미팅 일정 변경

(D) Organizing a team event 
→ 팀 행사가 아닌 미팅 일정 변경`,
      },
      {
        id: 2,
        question:
          "Why does <mark>the woman</mark> want to change the meeting time?",
        options: {
          A: "She has an <mark>urgent</mark> work <mark>matter</mark>",
          B: "She is feeling <mark>unwell</mark>",
          C: "She has a <mark>scheduling</mark> <mark>conflict</mark>",
          D: "She is <mark>out</mark> <mark>of</mark> <mark>town</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) She has an urgent work matter

대본 키워드: "Something urgent came up at work"
보기 키워드: "She has an urgent work matter"

❌ 오답 트랩:
(B) She is feeling unwell 
→ 몸이 아픈 것이 아닌 급한 업무

(C) She has a scheduling conflict 
→ 일정 충돌이 아닌 급한 업무

(D) She is out of town 
→ 출장이 아닌 급한 업무`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "<mark>Cancel</mark> the meeting",
          B: "Look for <mark>another</mark> <mark>venue</mark>",
          C: "<mark>Confirm</mark> the new schedule later",
          D: "Invite <mark>another</mark> <mark>person</mark> to the meeting",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Confirm the new schedule later

대본 키워드: "Let me confirm and get back to you"
보기 키워드: "Confirm the new schedule later"

❌ 오답 트랩:
(A) Cancel the meeting 
→ 취소가 아닌 일정 확인 후 연락

(B) Look for another venue 
→ 장소 변경이 아닌 일정 확인 후 연락

(D) Invite another person to the meeting 
→ 다른 사람 초대가 아닌 일정 확인 후 연락`,
      },
    ],
  },
  conversation5: {
    id: 5,
    title: "Rescheduling Coffee Meeting",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/daily/daily5.mp3",
        script: `<mark>M</mark>: Hi, Sophie. Are you still good for our <mark>coffee meeting this afternoon</mark>?
<span class="translation">(안녕하세요, Sophie. 오늘 오후 커피 미팅 여전히 괜찮으신가요?)</span>

<mark>W</mark>: Actually, something unexpected came up. My <mark>babysitter just canceled</mark>, so I need to stay home with my son.
<span class="translation">(사실, 예상치 못한 일이 생겼어요. 베이비시터가 방금 취소해서 아들과 집에 있어야 할 것 같아요.)</span>

<mark>M</mark>: Oh, I see. That must be difficult. Do you want to reschedule?
<span class="translation">(아, 그렇군요. 힘드시겠네요. 일정을 변경하시겠어요?)</span>

<mark>W</mark>: Yes, could we move it to <mark>Friday morning</mark> instead?
<span class="translation">(네, 대신 금요일 아침으로 옮길 수 있을까요?)</span>

<mark>M</mark>: That should work. Let's meet at the same café at <mark>10 AM</mark>.
<span class="translation">(괜찮을 것 같아요. 같은 카페에서 오전 10시에 만나요.)</span>

<mark>W</mark>: Perfect! Thanks for understanding.
<span class="translation">(좋아요! 이해해주셔서 감사합니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are the speakers discussing?",
        options: {
          A: "Changing the time of a <mark>meeting</mark>",
          B: "Planning a <mark>family</mark> <mark>event</mark>",
          C: "Cancelling a <mark>trip</mark>",
          D: "Scheduling a <mark>doctor's</mark> <mark>appointment</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Changing the time of a meeting

대본 키워드: "Could we move it to Friday morning instead?"
보기 키워드: "Changing the time of a meeting"

❌ 오답 트랩:
(B) Planning a family event 
→ 가족 행사가 아닌 미팅 시간 변경

(C) Cancelling a trip 
→ 여행 취소가 아닌 미팅 시간 변경

(D) Scheduling a doctor's appointment 
→ 병원 예약이 아닌 미팅 시간 변경`,
      },
      {
        id: 2,
        question: "Why does <mark>the woman</mark> need to reschedule?",
        options: {
          A: "Her <mark>babysitter</mark> canceled",
          B: "She has a <mark>business</mark> <mark>meeting</mark>",
          C: "She is <mark>not feeling</mark> <mark>well</mark>",
          D: "She got stuck in <mark>traffic</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Her babysitter canceled

대본 키워드: "My babysitter just canceled, so I need to stay home with my son"
보기 키워드: "Her babysitter canceled"

❌ 오답 트랩:
(B) She has a business meeting 
→ 업무 미팅이 아닌 베이비시터 취소

(C) She is not feeling well 
→ 몸이 아픈 것이 아닌 베이비시터 취소

(D) She got stuck in traffic 
→ 교통 체증이 아닌 베이비시터 취소`,
      },
      {
        id: 3,
        question: "When will the speakers most likely meet?",
        options: {
          A: "This <mark>afternoon</mark>",
          B: "Tomorrow <mark>evening</mark>",
          C: "Next <mark>Monday</mark>",
          D: "<mark>Friday</mark> morning",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) Friday morning

대본 키워드: "Let's meet at the same café at 10 AM"
보기 키워드: "Friday morning"

❌ 오답 트랩:
(A) This afternoon 
→ 오늘 오후가 아닌 금요일 오전

(B) Tomorrow evening 
→ 내일 저녁이 아닌 금요일 오전

(C) Next Monday 
→ 다음 월요일이 아닌 금요일 오전`,
      },
    ],
  },
  conversation6: {
    id: 6,
    title: "Haircut Appointment",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/daily/daily6.mp3",
        script: `<mark>W</mark>: Good afternoon. I'd like to schedule an appointment for a <mark>haircut</mark>.
<span class="translation">(안녕하세요. 헤어컷 예약을 하고 싶습니다.)</span>

<mark>M</mark>: Sure. When would you like to come in?
<span class="translation">(네. 언제 오시고 싶으신가요?)</span>

<mark>W</mark>: Do you have any openings this Saturday afternoon?
<span class="translation">(이번 토요일 오후에 자리가 있나요?)</span>

<mark>M</mark>: Let me check… We're <mark>fully booked</mark> in the afternoon, but we have an opening at <mark>10 AM</mark>.
<span class="translation">(확인해보겠습니다... 오후는 예약이 다 찼지만, 오전 10시에 자리가 있습니다.)</span>

<mark>W</mark>: That works for me. I'll take it.
<span class="translation">(그 시간 괜찮아요. 그걸로 하겠습니다.)</span>

<mark>M</mark>: Great. Your appointment is confirmed for 10 AM this Saturday.
<span class="translation">(좋습니다. 이번 토요일 오전 10시로 예약이 확정되었습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the call?",
        options: {
          A: "To ask about <mark>hair products</mark>",
          B: "To inquire about a <mark>new salon location</mark>",
          C: "To make a <mark>haircut appointment</mark>",
          D: "To <mark>cancel</mark> an existing <mark>appointment</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) To make a haircut appointment

대본 키워드: "I'd like to schedule an appointment for a haircut"
보기 키워드: "To make a haircut appointment"

❌ 오답 트랩:
(A) To ask about hair products 
→ 헤어 제품 문의가 아닌 헤어컷 예약

(B) To inquire about a new salon location 
→ 새 지점 문의가 아닌 헤어컷 예약

(D) To cancel an existing appointment 
→ 예약 취소가 아닌 헤어컷 예약`,
      },
      {
        id: 2,
        question: "When is <mark>the woman's</mark> appointment?",
        options: {
          A: "Friday at <mark>3 PM</mark>",
          B: "Saturday at <mark>10 AM</mark>",
          C: "Saturday at <mark>2 PM</mark>",
          D: "Sunday at <mark>noon</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Saturday at 10 AM

대본 키워드: "Your appointment is confirmed for 10 AM this Saturday"
보기 키워드: "Saturday at 10 AM"

❌ 오답 트랩:
(A) Friday at 3 PM 
→ 금요일이 아닌 토요일 오전 10시

(C) Saturday at 2 PM 
→ 오후 2시가 아닌 오전 10시

(D) Sunday at noon 
→ 일요일이 아닌 토요일 오전 10시`,
      },
      {
        id: 3,
        question:
          "What does <mark>the man</mark> say about the afternoon slots?",
        options: {
          A: "They are only available for <mark>regular</mark> <mark>customers</mark>",
          B: "They are <mark>fully</mark> <mark>booked</mark>",
          C: "They are cheaper than <mark>morning</mark> <mark>slots</mark>",
          D: "They are <mark>reserved</mark> for special <mark>services</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) They are fully booked

대본 키워드: "We're fully booked in the afternoon"
보기 키워드: "They are fully booked"

❌ 오답 트랩:
(A) They are only available for regular customers 
→ 단골 고객 전용이 아닌 예약 완료

(C) They are cheaper than morning slots 
→ 가격 차이가 아닌 예약 완료

(D) They are reserved for special services 
→ 특별 서비스용이 아닌 예약 완료`,
      },
    ],
  },
  // ... existing code ...

  conversation7: {
    id: 7,
    title: "Weekend Movie Plans",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/daily/daily7.mp3",
        script: `<mark>M</mark>: Hey, Jennifer. Do you have any plans for the <mark>weekend</mark>?
<span class="translation">(안녕하세요, Jennifer. 주말 계획 있으신가요?)</span>

<mark>W</mark>: Not really. I was thinking about going to see that new <mark>action movie</mark>. Have you heard about it?
<span class="translation">(딱히 없어요. 그 새로운 액션 영화를 보러 갈까 생각 중이었어요. 들어보셨나요?)</span>

<mark>M</mark>: Yeah, I have! I've been wanting to watch it too. Do you want to go together on <mark>Saturday evening</mark>?
<span class="translation">(네, 들어봤죠! 저도 보고 싶었어요. 토요일 저녁에 같이 볼래요?)</span>

<mark>W</mark>: That sounds good. I'll <mark>check the movie times</mark> and <mark>book the tickets</mark>.
<span class="translation">(좋아요. 영화 시간 확인하고 표를 예매할게요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are the speakers discussing?",
        options: {
          A: "Planning a weekend <mark>trip</mark>",
          B: "Going to see a <mark>movie</mark> together",
          C: "Visiting a new <mark>restaurant</mark>",
          D: "Attending a <mark>concert</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Going to see a movie together

대본 키워드: "I was thinking about going to see that new action movie", "Do you want to go together"
보기 키워드: "Going to see a movie together"

❌ 오답 트랩:
(A) Planning a weekend trip 
→ 여행이 아닌 영화 관람 계획

(C) Visiting a new restaurant 
→ 레스토랑이 아닌 영화 관람 계획

(D) Attending a concert 
→ 콘서트가 아닌 영화 관람 계획`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> say about the movie?",
        options: {
          A: "She has <mark>already</mark> <mark>seen</mark> it",
          B: "She was <mark>thinking</mark> about watching it",
          C: "It is only available <mark>online</mark>",
          D: "It is not an <mark>action</mark> <mark>movie</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) She was thinking about watching it

대본 키워드: "I was thinking about going to see that new action movie"
보기 키워드: "She was thinking about watching it"

❌ 오답 트랩:
(A) She has already seen it 
→ 이미 본 적이 없음

(C) It is only available online 
→ 온라인 상영에 대한 언급 없음

(D) It is not an action movie 
→ 액션 영화라고 언급됨`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> most likely do next?",
        options: {
          A: "<mark>Check</mark> the movie <mark>times</mark>",
          B: "Look for a <mark>different</mark> <mark>movie</mark>",
          C: "Invite <mark>more people</mark> to join",
          D: "Suggest a <mark>different</mark> <mark>activity</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Book the movie tickets

대본 키워드: "I'll check the movie times and book the tickets"
보기 키워드: "Book the movie tickets"

❌ 오답 트랩:
(A) Look for a different movie 
→ 다른 영화가 아닌 티켓 예매

(C) Invite more people to join 
→ 다른 사람 초대 계획 없음

(D) Suggest a different activity 
→ 다른 활동 제안 없음`,
      },
    ],
  },

  // ... existing code ...

  conversation8: {
    id: 8,
    title: "Photography Class Discussion",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/daily/daily8.mp3",
        script: `<mark>M</mark>: Hey, Anna. I heard you started a <mark>photography class</mark>. How is it going?
<span class="translation">(안녕하세요, Anna. 사진 수업을 시작했다고 들었어요. 어떠신가요?)</span>

<mark>W</mark>: It's really fun! I've learned a lot about lighting and composition.
<span class="translation">(정말 재미있어요! 조명과 구도에 대해 많이 배웠어요.)</span>

<mark>M</mark>: That sounds great. Where do you take the classes?
<span class="translation">(좋네요. 어디서 수업을 듣나요?)</span>

<mark>W</mark>: At the <mark>community center</mark> every Saturday morning. You should join!
<span class="translation">(매주 토요일 아침에 커뮤니티 센터에서요. 같이 하시는 게 어떠세요!)</span>

<mark>M</mark>: I'd love to, but I'm not sure if I have the right equipment.
<span class="translation">(하고 싶지만, 적절한 장비가 있는지 모르겠어요.)</span>

<mark>W</mark>: You don't need a fancy camera. The instructor said a <mark>smartphone</mark> is fine for beginners.
<span class="translation">(고급 카메라가 필요 없어요. 강사님이 초보자는 스마트폰으로도 충분하다고 하셨어요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are the speakers mainly discussing?",
        options: {
          A: "A <mark>new</mark> music <mark>club</mark>",
          B: "A <mark>local painting</mark> competition",
          C: "An <mark>outdoor hiking</mark> group",
          D: "A <mark>photography</mark> class",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) A photography class

대본 키워드: "I heard you started a photography class"
보기 키워드: "A photography class"

❌ 오답 트랩:
(A) A new music club 
→ 음악 클럽이 아닌 사진 수업

(B) A local painting competition 
→ 그림 대회가 아닌 사진 수업

(C) An outdoor hiking group 
→ 하이킹 모임이 아닌 사진 수업`,
      },
      {
        id: 2,
        question: "Where does <mark>the woman</mark> take the class?",
        options: {
          A: "At a <mark>university</mark>",
          B: "At a photography <mark>studio</mark>",
          C: "<mark>Online</mark>",
          D: "At a <mark>community</mark> <mark>center</mark>",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) At a community center

대본 키워드: "At the community center every Saturday morning"
보기 키워드: "At a community center"

❌ 오답 트랩:
(A) At a university 
→ 대학이 아닌 커뮤니티 센터

(B) At a photography studio 
→ 사진관이 아닌 커뮤니티 센터

(C) Online 
→ 온라인이 아닌 커뮤니티 센터`,
      },
      {
        id: 3,
        question:
          "What did <mark>the woman</mark> say about photography equipment?",
        options: {
          A: "A <mark>professional camera</mark> is necessary",
          B: "She will <mark>lend</mark> the man her <mark>camera</mark>",
          C: "The class provides <mark>free</mark> <mark>cameras</mark>",
          D: "A <mark>smartphone</mark> is enough for beginners",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) A smartphone is enough for beginners

대본 키워드: "The instructor said a smartphone is fine for beginners"
보기 키워드: "A smartphone is enough for beginners"

❌ 오답 트랩:
(A) A professional camera is necessary 
→ 전문가용 카메라가 아닌 스마트폰으로 충분

(B) She will lend the man her camera 
→ 카메라 대여가 아닌 스마트폰 사용 가능

(C) The class provides free cameras 
→ 무료 카메라 제공이 아닌 스마트폰 사용 가능`,
      },
    ],
  },
  conversation9: {
    id: 9,
    title: "Italy Trip Plans",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/daily/daily9.mp3",
        script: `<mark>W</mark>: Hey, David. I heard you're planning a <mark>trip</mark> next month. Where are you going?
<span class="translation">(안녕하세요, David. 다음 달에 여행 계획이 있다고 들었어요. 어디로 가시나요?)</span>

<mark>M</mark>: Yes! I'm going to <mark>Italy</mark> for a week. I've always wanted to visit Rome and Venice.
<span class="translation">(네! 일주일 동안 이탈리아에 갈 거예요. 로마와 베니스를 항상 가보고 싶었거든요.)</span>

<mark>W</mark>: That sounds amazing! Have you booked your flight yet?
<span class="translation">(멋지네요! 비행기 표는 예약하셨나요?)</span>

<mark>M</mark>: Not yet. I'm still <mark>comparing ticket prices</mark> to find the best deal.
<span class="translation">(아니요, 아직이요. 아직 가장 좋은 가격을 찾기 위해 항공권 가격을 비교하고 있어요.)</span>

<mark>W</mark>: Good idea. Let me know once you book it.
<span class="translation">(좋은 생각이에요. 예약하시면 알려주세요.)</span>

<mark>M</mark>: Sure. I'll send you the details later.
<span class="translation">(네. 나중에 자세한 내용을 보내드릴게요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the conversation mainly about?",
        options: {
          A: "A business <mark>conference</mark>",
          B: "Planning a trip to <mark>Italy</mark>",
          C: "Making a hotel <mark>reservation</mark>",
          D: "Learning a new <mark>language</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Planning a trip to Italy

대본 키워드: "I'm going to Italy for a week"
보기 키워드: "Planning a trip to Italy"

❌ 오답 트랩:
(A) A business conference 
→ 비즈니스 회의가 아닌 이탈리아 여행 계획

(C) Making a hotel reservation 
→ 호텔 예약이 아닌 이탈리아 여행 계획

(D) Learning a new language 
→ 언어 학습이 아닌 이탈리아 여행 계획`,
      },
      {
        id: 2,
        question: "What has <mark>the man</mark> NOT done yet?",
        options: {
          A: "Booked his <mark>flight</mark>",
          B: "Chosen a travel <mark>destination</mark>",
          C: "Made a packing <mark>list</mark>",
          D: "Applied for a travel <mark>visa</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Booked his flight

대본 키워드: "Not yet. I'm still comparing ticket prices"
보기 키워드: "Booked his flight"

❌ 오답 트랩:
(B) Chosen a travel destination 
→ 이미 이탈리아로 결정함

(C) Made a packing list 
→ 짐 목록에 대한 언급 없음

(D) Applied for a travel visa 
→ 비자 신청에 대한 언급 없음`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "Cancel his <mark>trip</mark>",
          B: "Look for a different <mark>destination</mark>",
          C: "Book his hotel <mark>first</mark>",
          D: "Compare flight prices and book a <mark>ticket</mark>",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) Compare flight prices and book a ticket

대본 키워드: "I'm still comparing ticket prices to find the best deal"
보기 키워드: "Compare flight prices and book a ticket"

❌ 오답 트랩:
(A) Cancel his trip 
→ 여행 취소가 아닌 항공권 가격 비교 및 예약

(B) Look for a different destination 
→ 다른 여행지가 아닌 항공권 가격 비교 및 예약

(C) Book his hotel first 
→ 호텔 예약이 아닌 항공권 가격 비교 및 예약`,
      },
    ],
  },
  // ... existing code ...

  conversation10: {
    id: 10,
    title: "Pizza Delivery Issue",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/daily/daily10.mp3",
        script: `<mark>M</mark>: Hello, I ordered a pizza an <mark>hour ago</mark>, but it hasn't arrived yet. Could you check the status for me?
<span class="translation">(안녕하세요, 한 시간 전에 피자를 주문했는데 아직 도착하지 않았어요. 상태를 확인해 주시겠어요?)</span>

<mark>W</mark>: I'm sorry for the <mark>delay</mark>. Let me check… It looks like the driver left the store <mark>20 minutes ago</mark>, so it should be there soon.
<span class="translation">(지연되어 죄송합니다. 확인해볼게요... 배달원이 20분 전에 가게를 출발했네요, 곧 도착할 거예요.)</span>

<mark>M</mark>: Alright. Also, I asked for a <mark>large pepperoni pizza</mark>, but I just want to confirm that the order was placed correctly.
<span class="translation">(알겠습니다. 그리고 라지 페퍼로니 피자를 주문했는데, 주문이 제대로 되었는지 확인하고 싶어서요.)</span>

<mark>W</mark>: Yes, I see a large pepperoni pizza on your order. If there's any issue, please <mark>call us back</mark>, and we'll take care of it.
<span class="translation">(네, 주문서에 라지 페퍼로니 피자가 있네요. 문제가 있으시다면 다시 전화해 주시면 처리해드리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the problem?",
        options: {
          A: "The man received the <mark>wrong</mark> <mark>order</mark>",
          B: "The food delivery is <mark>delayed</mark>",
          C: "The man's <mark>payment</mark> did not go through",
          D: "The restaurant is <mark>out</mark> of <mark>ingredients</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The food delivery is delayed

대본 키워드: "I ordered a pizza an hour ago, but it hasn't arrived yet"
보기 키워드: "The food delivery is delayed"

❌ 오답 트랩:
(A) The man received the wrong order 
→ 잘못된 주문 수령이 아닌 배달 지연

(C) The man's payment did not go through 
→ 결제 문제가 아닌 배달 지연

(D) The restaurant is out of ingredients 
→ 재료 부족이 아닌 배달 지연`,
      },
      {
        id: 2,
        question: "When did the delivery driver leave the store?",
        options: {
          A: "<mark>10</mark> minutes ago",
          B: "<mark>30</mark> minutes ago",
          C: "<mark>20</mark> minutes ago",
          D: "An <mark>hour</mark> ago",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) 20 minutes ago

대본 키워드: "It looks like the driver left the store 20 minutes ago"
보기 키워드: "20 minutes ago"

❌ 오답 트랩:
(A) 10 minutes ago 
→ 10분이 아닌 20분 전 출발

(B) 30 minutes ago 
→ 30분이 아닌 20분 전 출발

(D) An hour ago 
→ 1시간이 아닌 20분 전 출발`,
      },
      {
        id: 3,
        question:
          "What does <mark>the woman</mark> say the man should do if there is a problem?",
        options: {
          A: "<mark>Call</mark> back for assistance",
          B: "<mark>Pick up</mark> the order himself",
          C: "Speak with the delivery <mark>driver</mark>",
          D: "<mark>Visit</mark> the store for a refund",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Call back for assistance

대본 키워드: "If there's any issue, please call us back"
보기 키워드: "Call back for assistance"

❌ 오답 트랩:
(B) Pick up the order himself 
→ 직접 수령 요청이 아닌 전화 요청

(C) Speak with the delivery driver 
→ 배달원 연락이 아닌 가게로 전화 요청

(D) Visit the store for a refund 
→ 가게 방문이 아닌 전화 요청`,
      },
    ],
  },

  // ... existing code ...
  conversation11: {
    id: 11,
    title: "Meeting Rescheduling",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/daily/daily11.mp3",
        script: `<mark>M</mark>: Hi, Olivia. I wanted to check if we're still on for our <mark>meeting</mark> this Thursday.
<span class="translation">(안녕하세요, Olivia. 이번 목요일 미팅이 여전히 유효한지 확인하고 싶었어요.)</span>

<mark>W</mark>: Actually, I was just about to call you. I need to <mark>reschedule</mark> because something <mark>urgent</mark> came up.
<span class="translation">(사실, 전화드리려던 참이었어요. 급한 일이 생겨서 일정을 변경해야 할 것 같아요.)</span>

<mark>M</mark>: Oh, I see. When would be a better time for you?
<span class="translation">(아, 그렇군요. 언제가 더 좋으신가요?)</span>

<mark>W</mark>: Could we move it to Friday morning instead?
<span class="translation">(금요일 아침으로 옮길 수 있을까요?)</span>

<mark>M</mark>: That should work. Let me <mark>double-check my schedule</mark> and confirm later.
<span class="translation">(괜찮을 것 같아요. 제 일정을 다시 한 번 확인하고 나중에 알려드릴게요.)</span>

<mark>W</mark>: Sounds good. Thanks for understanding!
<span class="translation">(좋아요. 이해해주셔서 감사합니다!)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the conversation mainly about?",
        options: {
          A: "Making a travel <mark>reservation</mark>",
          B: "Discussing a project <mark>deadline</mark>",
          C: "Rescheduling a <mark>meeting</mark>",
          D: "Booking a <mark>hotel</mark> <mark>room</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Rescheduling a meeting

대본 키워드: "I need to reschedule because something urgent came up"
보기 키워드: "Rescheduling a meeting"

❌ 오답 트랩:
(A) Making a travel reservation 
→ 여행 예약이 아닌 미팅 일정 변경

(B) Discussing a project deadline 
→ 프로젝트 기한이 아닌 미팅 일정 변경

(D) Booking a hotel room 
→ 호텔 예약이 아닌 미팅 일정 변경`,
      },
      {
        id: 2,
        question: "Why does <mark>the woman</mark> need to reschedule?",
        options: {
          A: "She is <mark>traveling</mark> <mark>for</mark> <mark>work</mark>",
          B: "She <mark>forgot</mark> about the <mark>meeting</mark>",
          C: "She has an <mark>urgent matter</mark> to handle",
          D: "She is <mark>sick</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) She has an urgent matter to handle

대본 키워드: "something urgent came up"
보기 키워드: "She has an urgent matter to handle"

❌ 오답 트랩:
(A) She is traveling for work 
→ 출장이 아닌 급한 일

(B) She forgot about the meeting 
→ 잊어버린 것이 아닌 급한 일

(D) She is sick 
→ 아픈 것이 아닌 급한 일`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "Check his schedule and confirm the <mark>new</mark> <mark>time</mark>",
          B: "<mark>Cancel</mark> the meeting",
          C: "Find a <mark>different</mark> meeting <mark>location</mark>",
          D: "Invite <mark>another</mark> <mark>colleague</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Check his schedule and confirm the new time

대본 키워드: "Let me double-check my schedule and confirm later"
보기 키워드: "Check his schedule and confirm the new time"

❌ 오답 트랩:
(B) Cancel the meeting 
→ 취소가 아닌 일정 확인 후 연락

(C) Find a different meeting location 
→ 장소 변경이 아닌 일정 확인 후 연락

(D) Invite another colleague 
→ 다른 동료 초대가 아닌 일정 확인 후 연락`,
      },
    ],
  },
};
